import { MenuDrawer } from './dumb.js';

export default MenuDrawer;
